<div class="mb-2 fw-bold">
  Add Job
  <span class="cursor-pointer">
    {{ selectedJobType?.name ? " > " + selectedJobType?.name : "" }}</span
  >
</div>
<div class="row row-cols-1 row-cols-lg-2">
  <div class="col mb-5">
    <!-- Form begins -->
    <form [formGroup]="adHocFormData">
      <!-- Site name input -->

      <div class="row row-cols-2 my-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-dark w-100"
            [routerLink]="['/jobs']"
            [queryParams]="{ cancel: true }"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-primary btn-lg w-100"
            [disabled]="!adHocJobType.site.data || addJobPressed"
            (click)="onAddJob()"
          >
            Add Job
          </button>
        </div>
      </div>

      @if (adHocJobType.site.data?.id) {
        <div class="mb-2">
          <dl>
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <dt>Site</dt>
                <dd>
                  {{ adHocJobType.site.value }}
                  <div>[{{ adHocJobType.client.value }}]</div>
                </dd>
              </div>
              <div>
                <span (click)="editField('site')">
                  <i
                    class="fa-solid fa-pen-to-square md-font-size text-secondary"
                  ></i
                ></span>
              </div>
            </div>
          </dl>
        </div>
      }
      @if (!adHocJobType.site.data?.id) {
        <div class="mb-3">
          <gtapp-auto-complete
            [data]="siteList"
            placeHolder="Select Site"
            searchKeyword="company_name"
            [initialValue]="adHocFormData.value.siteName"
            [itemTemplate]="siteTemplate"
            [addInitialKey]="isAdmin || isDispatchUser"
            (inputChanged)="onSiteSearch($event)"
            (selected)="onSelectSite($event)"
            [inputId]="'siteId'"
            [enableCloseOption]="true"
            (fieldCleared)="editField('site')"
          >
          </gtapp-auto-complete>
        </div>
      }

      <ng-template #siteTemplate let-item>
        @if (item?.key === 0) {
          <div>Create New Site</div>
        } @else {
          <div>
            <div class="fw-medium">
              {{ item?.company_name }} [{{ item?.company?.company_name }}]
            </div>

            <div class="small-font text-secondary">
              {{ item?.address?.full_address }}
            </div>
          </div>
        }
      </ng-template>

      @if (adHocJobType.site.data) {
        <!-- Monitoring Company -->
        @if (adHocJobType.mc.data?.id) {
          <div class="mb-2">
            <dl>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <dt>Monitoring Company</dt>
                  <dd>
                    {{ adHocJobType.mc.value }}
                  </dd>
                </div>
                <div>
                  <span (click)="editField('mc')">
                    <i
                      class="fa-solid fa-pen-to-square md-font-size text-secondary"
                    ></i
                  ></span>
                </div>
              </div>
            </dl>
          </div>
        }
        @if (!adHocJobType.mc.data?.id) {
          <div class="mb-3">
            <gtapp-auto-complete
              [data]="monitoringCompanyList"
              placeHolder="Monitoring Company"
              searchKeyword="company_name"
              [initialValue]="adHocFormData.value.monitoringCompanyName"
              [itemTemplate]="MCTemplate"
              [addInitialKey]="isAdmin && adHocJobType.mc.tempValue"
              (inputChanged)="onMcSearch($event)"
              (selected)="onMonitoringSelect($event)"
              [inputId]="'mcId'"
              [enableCloseOption]="true"
              (fieldCleared)="editField('mc')"
            >
            </gtapp-auto-complete>
          </div>
        }
        <ng-template #MCTemplate let-item>
          @if (item?.key === 0) {
            <div>Add Monitoring Company</div>
          } @else {
            <div>
              {{ item.company_name }}
            </div>
          }
        </ng-template>
        <div class="form-floating mb-3">
          <input
            class="form-control"
            id="jobNumber"
            type="text"
            placeholder="Job Number"
            formControlName="externalJobId"
            autocomplete="off"
          />
          <label>Job Number</label>
        </div>
        <!-- Selected Site Keys Info-->
        <div class="mb-2">
          @if (adHocJobType?.site.data?.id) {
            <gtapp-site-keys
              [selectedSite]="adHocJobType?.site.data"
              (updateSiteInfo)="siteKeyInternalCheck($event)"
            ></gtapp-site-keys>
          }
        </div>
        @if (siteKeyList?.length) {
          <div class="mb-4">
            <label>
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="sealInfo?.internal_check"
                (change)="
                  sealInfo?.internal_check
                    ? (sealInfo = {})
                    : (sealInfo.internal_check = true)
                "
              />
              Internal Check (Seal) Required</label
            >
          </div>
        }
        <!-- Assign Guard -->
        @if (selectedJobType.enable_assignees === true) {
          <div>
            @if (adHocJobType.assignee.data?.id) {
              <div class="mb-2">
                <dl>
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <dt>Assigned To</dt>
                      <dd>
                        <span
                          [gtappPopover]="userDetailPopoverTemplate"
                          [popoverData]="{
                            userId: adHocJobType.assignee.data?.id,
                          }"
                        >
                          {{ adHocFormData.value.assigneeName }}</span
                        >
                      </dd>
                    </div>
                    <div>
                      <span (click)="editField('assignee')">
                        <i
                          class="fa-solid fa-pen-to-square md-font-size text-secondary"
                        ></i
                      ></span>
                    </div>
                  </div>
                </dl>
              </div>
            }
            @if (!adHocJobType.assignee.data?.id) {
              <div class="mb-3">
                <gtapp-auto-complete
                  [data]="assigneeList"
                  placeHolder="Assign To"
                  searchKeyword="full_name"
                  [initialValue]="adHocFormData.value.assigneeName"
                  [itemTemplate]="assigneeTemplate"
                  (inputChanged)="onAssigneeSearch($event)"
                  (selected)="onAssigneeSelect($event)"
                  [inputId]="'assigneeId'"
                  [enableCloseOption]="true"
                  (fieldCleared)="editField('assignee')"
                >
                </gtapp-auto-complete>
              </div>
            }
            <ng-template #assigneeTemplate let-item>
              <div class="d-flex gap-2 flex-wrap">
                <span>
                  {{ item?.full_name }}
                </span>
                @if (item?.access_status === 2) {
                  <div
                    class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                  >
                    Casual
                  </div>
                }
                @if (
                  selectedSiteExtraDetails?.preferred_user_ids?.includes(
                    item?.id
                  )
                ) {
                  <div
                    class="text-success-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                  >
                    Preferred
                  </div>
                }
              </div>

              @if (selectedSiteExtraDetails?.last_assignees?.[item?.id]) {
                <div class="small text-secondary">
                  Previously Assigned:
                  @if (
                    (selectedSiteExtraDetails?.last_assignees?.[item?.id]
                      | misc: "getXDaysAgo") > 1
                  ) {
                    {{
                      selectedSiteExtraDetails?.last_assignees?.[item?.id]
                        | misc: "getXDaysAgo"
                    }}
                    day(s) ago |
                  } @else {}
                  {{
                    selectedSiteExtraDetails?.last_assignees?.[item?.id]
                      | misc: "eventDateGrouping"
                  }}
                </div>
              }
              @if (item?.subcontractors?.length) {
                <div class="small text-secondary">
                  🟧Subcontractor:
                  <span class="subcontractor-name">{{
                    item?.subcontractors
                  }}</span>
                </div>
              }
            </ng-template>
          </div>
        }
        <!-- Response Type -->
        @if (adHocJobType.rt.data?.id) {
          <div class="mb-2">
            <dl>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <dt>Response Type</dt>
                  <dd>
                    {{ adHocJobType.rt.value }}
                  </dd>
                </div>
                <div>
                  <span (click)="editField('rt')">
                    <i
                      class="fa-solid fa-pen-to-square md-font-size text-secondary"
                    ></i
                  ></span>
                </div>
              </div>
            </dl>
          </div>
        }
        @if (!adHocJobType.rt.data?.id) {
          <div class="mb-3">
            <gtapp-auto-complete
              [data]="responseTypeList"
              placeHolder="Select Response Type"
              searchKeyword="name"
              [initialValue]="adHocFormData.value.responseTypeName"
              [itemTemplate]="responseTypeTemplate"
              [addInitialKey]="isAdmin && adHocJobType.rt.tempValue"
              (inputChanged)="onRtSearch($event)"
              (selected)="onResponseTypeSelect($event)"
              [inputId]="'rtId'"
              [enableCloseOption]="true"
              (fieldCleared)="editField('rt')"
            >
            </gtapp-auto-complete>
            <ng-template #responseTypeTemplate let-item>
              @if (item?.key === 0) {
                <div>Add Response Type</div>
              } @else {
                <div>
                  {{ item.name }}
                </div>
              }
            </ng-template>
          </div>
        }
        <div class="row mb-3">
          @if (largeView) {
            <div class="form-group input-group col">
              <textarea
                class="form-control"
                placeholder="Additional Information"
                rows="5"
                wrap="hard"
                maxlength="900"
                type="text"
                autofocus
                [(ngModel)]="adHocJobType.ai.value"
                formControlName="requestDetail"
                id="aiTextBox"
              ></textarea>
              @if (adHocJobType?.ai?.value) {
                <span
                  class="input-group-text"
                  (click)="
                    adHocJobType.ai.value = '';
                    adHocFormData.controls['requestDetail'].setValue('');
                    shiftFocus('aiTextBox')
                  "
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
            <div class="form-group input-group col">
              <textarea
                class="form-control"
                placeholder="Internal Notes (Will not be shown on reports)"
                rows="5"
                wrap="hard"
                maxlength="900"
                type="text"
                autofocus
                [(ngModel)]="adHocJobType.in.value"
                formControlName="internal_notes"
                id="inTextBox"
              ></textarea>
              @if (adHocJobType?.in?.value) {
                <span
                  class="input-group-text"
                  (click)="
                    adHocJobType.in.value = '';
                    adHocFormData.controls['internal_notes'].setValue('');
                    shiftFocus('inTextBox')
                  "
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          } @else {
            <div class="col">
              <div class="mb-3">
                <button
                  (click)="openTemplate(jobExtraInfoTempalte, 'ai')"
                  class="btn btn-lg w-100"
                  [ngClass]="
                    adHocJobType.ai.value ? 'btn-info' : 'btn-outline-info'
                  "
                >
                  Additional Information
                </button>
              </div>
              <div>
                <button
                  (click)="openTemplate(jobExtraInfoTempalte, 'in')"
                  class="btn btn-lg w-100"
                  [ngClass]="
                    adHocJobType.in.value ? 'btn-info' : 'btn-outline-info'
                  "
                >
                  Internal Notes
                </button>
              </div>
            </div>
          }
        </div>
        @if (adHocJobType.oc.data?.id) {
          <div class="mb-2">
            <dl>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <dt>Site Contact</dt>
                  <dd>
                    {{ adHocJobType.oc.value }}
                  </dd>
                </div>
                <div>
                  <span (click)="editField('oc')">
                    <i
                      class="fa-solid fa-pen-to-square md-font-size text-secondary"
                    ></i
                  ></span>
                </div>
              </div>
            </dl>
          </div>
        }
        @if (!adHocJobType.oc.data?.id) {
          <div class="mb-3">
            <gtapp-auto-complete
              [data]="siteContacts"
              placeHolder="Onsite Contact (Optional)"
              searchKeyword="full_name"
              [initialValue]="adHocFormData.value.siteContactName"
              [itemTemplate]="siteContactSearch"
              [addInitialKey]="true"
              (selected)="selectContact($event)"
              [inputId]="'ocId'"
              [enableCloseOption]="true"
              (fieldCleared)="editField('oc')"
            >
            </gtapp-auto-complete>
          </div>
        }
        <ng-template #siteContactSearch let-item>
          @if (item?.key === 0) {
            @if (isAdmin && adHocJobType.site.data) {
              <div>Add New Contact</div>
            }
          } @else {
            <div>
              {{ item?.full_name }}
            </div>
          }
        </ng-template>
        <div class="row row-cols-2 my-3">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-dark w-100"
              [routerLink]="['/jobs']"
              [queryParams]="{ cancel: true }"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-primary btn-lg w-100"
              [disabled]="!adHocJobType?.site?.data?.id || addJobPressed"
              (click)="onAddJob()"
            >
              Add Job
            </button>
          </div>
        </div>
      }
    </form>
  </div>

  <div class="col">
    @if (
      showSiteMap &&
      (adHocJobType.site?.data?.address?.latitude ||
        adHocJobType.site?.data?.gps?.lat) &&
      (adHocJobType.site?.data?.address?.longitude ||
        adHocJobType.site?.data?.gps?.lon) &&
      largeView
    ) {
      <div>
        <gtapp-map-leaflet
          [latLon]="{
            lat:
              adHocJobType.site?.data?.address?.latitude ||
              adHocJobType.site?.data?.gps?.lat,
            lon:
              adHocJobType.site?.data?.address?.longitude ||
              adHocJobType.site?.data?.gps?.lon,
          }"
          [mapId]="'largeJob'"
        ></gtapp-map-leaflet>
      </div>
    }
  </div>
</div>

<!-- Additional Information/ Internal Notes POPOVER / DIALOG -->
<ng-template
  #jobExtraInfoTempalte
  let-data
  let-jobExtraInfoTempalte="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      {{ data === "ai" ? "Additional Information " : "Internal Notes" }}
    </div>

    <!-- Request Detail Section start-->
    @if (data === "in") {
      <div class="small mb-3">Will not be shown on reports</div>
    }

    <div class="form-group input-group">
      <textarea
        class="form-control"
        [placeholder]="
          data === 'ai' ? 'Additional Information ' : 'Internal Notes'
        "
        rows="5"
        wrap="hard"
        maxlength="900"
        type="text"
        autofocus
        [(ngModel)]="adHocJobType[data].value"
        id="aiTextBox"
      ></textarea>
      @if (adHocJobType?.[data]?.value) {
        <span
          class="input-group-text"
          (click)="adHocJobType[data].value = ''; shiftFocus('aiTextBox')"
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>

    <div class="row my-2">
      <div class="col">
        <button
          class="btn btn-lg w-100"
          [ngClass]="adHocJobType?.[data]?.value ? 'btn-primary' : 'btn-dark'"
          (click)="jobExtraInfoTempalte.close(); updateJobExtraInfo(data)"
        >
          {{ adHocJobType?.[data]?.value ? "Save" : "Close" }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
